var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 13.8334C4.77838 13.8334 2.16671 11.2217 2.16671 8.00004C2.16671 4.77838 4.77838 2.16671 8.00004 2.16671C11.2217 2.16671 13.8334 4.77838 13.8334 8.00004C13.8334 11.2217 11.2217 13.8334 8.00004 13.8334ZM8.00004 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8.00004C14.6667 4.31814 11.6819 1.33337 8.00004 1.33337C4.31814 1.33337 1.33337 4.31814 1.33337 8.00004C1.33337 11.6819 4.31814 14.6667 8.00004 14.6667Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16799 10.5C7.16799 10.0398 7.54109 9.66671 8.00133 9.66671C8.46156 9.66671 8.83466 10.0398 8.83466 10.5C8.83466 10.9603 8.46156 11.3334 8.00133 11.3334C7.54109 11.3334 7.16799 10.9603 7.16799 10.5Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24963 5.49591C7.20523 5.05194 7.55387 4.66671 8.00004 4.66671C8.44622 4.66671 8.79485 5.05194 8.75045 5.49591L8.45817 8.41878C8.43463 8.65414 8.23658 8.83337 8.00004 8.83337C7.7635 8.83337 7.56545 8.65414 7.54191 8.41878L7.24963 5.49591Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.d948c6c4ea2cb861a49401a0ff005c4f.svg";
export { ForwardRef as ReactComponent };